export default __webpack_public_path__ + "static/farm_equipment_upgrade-ee37b990633fe08cf445df2f2a3b4dde.png";